<template>
  <div></div>
</template>

<script>
import { channelType } from '@/config/index.js';
export default {
  data() {
    return {};
  },
  created() {
    if (channelType == 'channel_hm') {
      //渠道一活动跳转
      const _url = 'http://hm.hzwxbz3.cn/#/activity/seckill?activity_id=4';
      window.open(_url, '_self');
    } else {
      //渠道三活动跳转
      const _url = 'http://hm.hnyuezan.com/#/activity/seckill?activity_id=5';
      window.open(_url, '_self');
    }
  },
};
</script>

<style lang='scss' scoped>
</style>
